export default {
      id: "maps_default-usage",
      viewBox: "0 0 51 74",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#maps_default-usage",
      toString: function () {
        return this.url;
      }
    }